"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HomeFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HomeFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10.998V13c0 .932 0 1.398-.152 1.766a2 2 0 0 1-1.083 1.083C4.398 16 3.932 16 3 16c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C0 14.397 0 13.93 0 12.999v-5.71c0-.548 0-.823.068-1.077.06-.226.16-.439.294-.63.151-.216.361-.392.782-.745l3.771-3.165C6.012.752 6.561.292 7.173.116a2.999 2.999 0 0 1 1.654 0c.612.176 1.16.636 2.258 1.556l3.771 3.165c.42.353.631.53.782.745a2 2 0 0 1 .294.63C16 6.466 16 6.74 16 7.29v5.709c0 .932 0 1.398-.152 1.766a2 2 0 0 1-1.083 1.083C14.398 16 13.932 16 13 16c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C10 14.397 10 13.93 10 12.999v-2c0-.466 0-.699-.051-.89a1.5 1.5 0 0 0-1.06-1.06c-.192-.051-.424-.051-.889-.051s-.697 0-.888.05a1.5 1.5 0 0 0-1.06 1.062C6 10.3 6 10.533 6 10.998Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HomeFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HomeFill;
exports["default"] = _default;